module.exports = __webpack_public_path__ + "img/musang-king.79b6a33f.jpeg";